import React, {useState} from 'react';
import "./styles/TextEditor.scss"
import {LexicalComposer} from "@lexical/react/LexicalComposer";
import { HeadingNode } from "@lexical/rich-text"
import {RichTextPlugin} from "@lexical/react/LexicalRichTextPlugin";
import {ContentEditable} from "@lexical/react/LexicalContentEditable";
import {LexicalErrorBoundary} from "@lexical/react/LexicalErrorBoundary";
import {isRTL} from "../../../services/i18n";
import ToolbarPlugin from "./plugins/ToolbarPlugin";
import {editorTheme} from "./helper";
import {HistoryPlugin} from "@lexical/react/LexicalHistoryPlugin";
import "./styles/TextFormatStyling.scss"
import { ListNode, ListItemNode } from '@lexical/list';
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { AutoFocusPlugin } from "@lexical/react/LexicalAutoFocusPlugin";
import CustomOnChangePlugin from "./plugins/CustomOnChangePlugin";
import {HighlightNode} from "./nodes/HighlightNode";
import { TableNode, TableCellNode, TableRowNode } from '@lexical/table';
import {TablePlugin} from "@lexical/react/LexicalTablePlugin";
import TableCellActionPlugin from "./plugins/TableCellActionPlugin";
import TableResizePlugin from "./plugins/TableResizePlugin";

const TextEditor = (props) => {
    const { placeholder, onChange, value, allowTable } = props;
    const [anchor, setAnchor] = useState(null);

    const initialConfig = {
        namespace: 'rich-text-editor',
        theme: editorTheme,
        onError: () => {},
        nodes: [HeadingNode, ListNode, ListItemNode, HighlightNode, TableNode, TableCellNode, TableRowNode]
    }

    const onRef = (_floatingAnchorElem) => {
        if (_floatingAnchorElem !== null) {
            setAnchor(_floatingAnchorElem);
        }
    };

    return (
        <div id={'lexical-text-editor'}>
            <LexicalComposer initialConfig={initialConfig}>
                <ToolbarPlugin allowTable={allowTable}/>
                <div style={{position: 'relative', height: 'calc(100% - 52px)'}} ref={onRef}>
                    <RichTextPlugin contentEditable={<ContentEditable id={'lexical-rich-text-content'}/>}
                                    ErrorBoundary={LexicalErrorBoundary}
                                    placeholder={<div className={`editor-placeholder ${isRTL() && 'position-rtl'}`}>{placeholder}</div>}
                    />
                </div>
                <ListPlugin/>
                <AutoFocusPlugin/>
                <HistoryPlugin/>
                <TablePlugin/>
                <CustomOnChangePlugin onChange={onChange} value={value}/>
                {anchor &&
                    <>
                    <TableCellActionPlugin anchor={anchor}/>
                    <TableResizePlugin anchor={anchor}/>
                    </>
                }
            </LexicalComposer>
        </div>
    );
};

export default TextEditor;